module.exports = __webpack_public_path__ + "img/loading-tail-spin.c223bcb3.svg";